import { IUser } from '@core/models';
import { createAction, props } from '@ngrx/store';

export const setUser = createAction('[User] Set user', props<{ value: IUser }>());

export const delUser = createAction('[User] Del user');

export const disableFirstLoginUser = createAction('[User] disable first login user');

export const userActiveApp = createAction('[User] active app', props<{ value: string }>());
